/**
 * Shared GTFS stop id normalization helpers used across map and services layers.
 */

/**
 * Strips the optional `Parent` prefix from GTFS parent station ids.
 *
 * @param parentStation Raw GTFS `parent_station` value.
 * @returns Normalized parent suffix used for child matching.
 */
export const normalizeGtfsParentStationId = ( parentStation: string ): string => parentStation.trim().replace( /^Parent/, "" );

/**
 * Returns the unprefixed GTFS stop id suffix (`{gtfs_source}_` removed when known).
 *
 * @param stopId Prefixed stop id from the spatial index.
 * @param gtfsSource GTFS source prefix when available.
 * @returns Stop id suffix without the source prefix.
 */
export const getGtfsStopIdSuffix = ( stopId: string, gtfsSource: string | null ): string => {
    const sourcePrefix = gtfsSource !== null && gtfsSource !== "" ? `${ gtfsSource }_` : "";

    if ( sourcePrefix !== "" && stopId.startsWith( sourcePrefix ) ) {
        return stopId.slice( sourcePrefix.length );
    }

    const underscoreIndex = stopId.indexOf( "_" );

    return underscoreIndex >= 0 ? stopId.slice( underscoreIndex + 1 ) : stopId;
};
